import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Alert, Form } from "react-bootstrap";
import { getToken } from "../utils/auth";
import countries from "../data/countries";
import { Helmet } from "react-helmet-async";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstname: "",
    lastname: "",
    country: "",
  });

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken()) {
      navigate("/profile");
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (formData.password !== formData.confirmPassword) {
      setError("❌ Passwords do not match");
      return;
    }

    try {
      const response = await fetch("/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
          firstname: formData.firstname,
          lastname: formData.lastname,
          country: formData.country,
        }),
      });

      if (response.ok) {
        setMessage(
          "✅ Registration successful! An activation link has been sent to your email. You will be redirected to the login form in 10 seconds."
        );
        setSubmitted(true);
        setTimeout(() => navigate("/login"), 10000);
      } else {
        const errorData = await response.json();
        setError(`❌ Ошибка: ${errorData.detail}`);
      }
    } catch {
      setError("❌ The server is temporarily unavailable, please try again later.");
    }
  };

  return (<>
  
        <Helmet>
        <title>Register an Account | IndexBooster</title>
        <meta name="description" content="Your primary IndexBooster account in just a few easy steps to start indexing your URLs instantly. Track results in real time!" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Register an Account | IndexBooster" />
        <meta property="og:description" content="Your primary IndexBooster account in just a few easy steps to start indexing your URLs instantly. Track results in real time!" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Register an Account | IndexBooster" />
        <meta name="twitter:description" content="Your primary IndexBooster account in just a few easy steps to start indexing your URLs instantly. Track results in real time!" />
      </Helmet>
  
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Card style={{ width: "400px", padding: "20px" }}>
        <Card.Body>
          <h1 className="text-center">Register</h1>
          {message && <Alert variant="success">{message}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          {!submitted && (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Firstname</Form.Label>
                <Form.Control type="text" name="firstname" value={formData.firstname} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Lastname</Form.Label>
                <Form.Control type="text" name="lastname" value={formData.lastname} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <Form.Select name="country" value={formData.country} onChange={handleChange} required>
                  <option value="">Select your country</option>
                  {countries.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" name="password" value={formData.password} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Repeat Password</Form.Label>
                <Form.Control type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="termsCheckbox"
                  label={
                    <>
                      I agree with the{" "}
                      <a href="https://indexbooster.net/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms of Service</a>{" "}
                      and{" "}
                      <a href="https://indexbooster.net/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    </>
                  }
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="w-100 mt-3" disabled={!agreed}>
                Register
              </Button>

              <div className="text-center mt-3">
                <a href="/login">Already registered? Sign In</a>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </div>
 </> );
};

export default Register;